<template>
    <v-container fluid>   
      <LeftMenu/>     
        <v-layout row wrap>   
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              :headers="headers"
              :items="salesFormatted"
              :items-per-page="50"
              item-key="id"
              sort-by="saleDate"
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Sales</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>                 
                  <v-flex xs2 class="pr-3">
                    <DatePicker picker-label="" :date-value="salesStartDate" @dateSelected="salesStartDate=$event" />
                  </v-flex>
                  <v-flex xs2 class="pr-3"> 
                    <DatePicker picker-label="" :date-value="salesEndDate" @dateSelected="salesEndDate=$event" />                  
                  </v-flex> 
                   <v-flex xs5>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="900px">
                    <template v-slot:activator="{ on }">
                      <!--<v-btn color="primary" dark class="mb-2" v-on="on">New Sale</v-btn>-->
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12 sm6 md6 v-if="editedItem.offer">
                              <v-text-field v-model="editedItem.offer.customer.customerName" 
                                label="Customer Name" :readonly="true"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md6 v-if="editedItem.offer">
                              <v-text-field v-model="editedItem.offer.customer.company" label="Company" :readonly="true"></v-text-field>
                            </v-flex>   

                            <v-flex xs12 sm6 md6 v-if="!editedItem.offer">
                              <v-combobox
                                :items="customersComputed"
                                label="Select Customer"
                                v-model="editedItem.customer"
                                item-text="customerName"
                                single-line
                                return-object
                                :rules="[rules.required]"
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm3 md3 >
                              <v-combobox
                                :items="salePersonnels"
                                label="Select Salesman"
                                v-model="editedItem.salePersonnel"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm3 md3 >
                              <v-combobox
                                :items="officePersonnels"
                                label="Select Office Personnel"
                                v-model="editedItem.officePersonnel"
                                item-text="name"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <DatePicker picker-label="Sale Date" :date-value="editedItem.saleDate" @dateSelected="editedItem.saleDate=$event" />
                            </v-flex> 
                            <v-flex xs12 sm6 md4>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.taxAmount" label="Tax Amount"></v-currency-field>
                            </v-flex>
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                       
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>                                   
                </v-toolbar> 
                <v-layout row wrap>                 
                  <v-flex xs1/>  
                  <v-flex xs1 align-self-center="true">  
                    <Xlsx filename="sales" :items="xlsxItems"  :headers="xlsxHeaders" />                                      
                  </v-flex>
                  <v-flex xs1/>   
                  <v-flex xs1 align-self-center="true">
                  {{totalText}}:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalSaleUSDAmountFormatted}} USD                   
                  </v-flex>    
                  <v-flex xs1 align-self-center="true">
                  {{totalText}}:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalSaleAmountFormatted}} TRY                                      
                  </v-flex>  
                  <v-flex xs2 align-self-baseline="center">
                      <v-switch color="red" v-model="showUnpaid" class="mx-2" label="Show Unpaid"></v-switch>  
                  </v-flex>  
                </v-layout>                                     
              </template>               
              <template v-slot:body.append>                                 
              </template>     
              <template v-slot:item.goToOfferDetails="{ item }">                 
                <a v-if="item.offer" @click.prevent="goToOfferDetails(item.offer)">{{ item.offer.offerNoText}}</a>           
              </template>   
              <template v-slot:item.unpaidAmountFormatted="{ item }">                            
                <div v-bind:class="{ paymentNotReceived: !item.paymentReceived }">
                  {{item.unpaidAmountFormatted}}             
                </div>
              </template>                 
              <template v-slot:item.salesActions="{ item }">                            
                <v-icon                  
                  @click="editItem(item)">
                  mdi-table-edit
                </v-icon>
                <v-icon                  
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Xlsx from '../components/Xlsx';
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';
import concatStr from '../helpers/strutil';
import getCurrentDate from '../helpers/getCurrentDate';
import getCurrentMonthStart from '../helpers/getCurrentMonthStart';
const API_URL = 'sales';
const CURRENCIES_API_URL = 'definitions/currencies';
const CUSTOMERS_API_URL = 'definitions/customers';
const SALESMAN_API_URL = 'definitions/personnel/department/SALES';
const OFFICEMAN_API_URL = 'definitions/personnel/department/USA';
export default {
  components:{
    LeftMenu,
    DatePicker,
    Xlsx
  },
  data () {
    return {
      dialog: false,
      search: '',
      showUnpaid : false,
      salesStartDate: '',
      salesEndDate: '',
      totalSaleAmount: 0,
      totalSaleAmountUSD: 0,
      totalSaleUSDAmountFormatted: 0,
      totalSaleAmountFormatted: 0,
      currencyList: [],
      salePersonnels: [],
      officePersonnels: [],
      totalText : 'Total',
      customers: [],
      sales: [],
      editedIndex: -1,
      editedItem: {
        category: '',
        amount: 0,
      },
      defaultItem: {
        category: '',
        amount: 0, 
      },
      rules: {
        required: value => {
          return !!value || 'Required.';
        }
      },
      xlsxHeaders: {
        id : 'Sale Id' ,
        saleDate : 'Sale Date' ,
        customer : 'Customer' ,
        company : 'Company'  ,   
        country : 'Country'  ,    
        amount : 'Amount' ,        
        received : 'Received' ,
        unpaid : 'Unpaid' ,
        currency : 'Currency',
        tax : 'Tax',
        net : 'Net Amount'
      },
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Sale Id',align: 'left',sortable: true, value: 'id'},
        { text: 'Offer No',align: 'left',sortable: true, value: 'goToOfferDetails'},
        { text: 'Sale Date', value: 'saleDate' },
        //{ text: 'Offer Id',align: 'left',sortable: true,value: 'offer.id'},
        { text: 'Customer',  value: 'customerName'  },
        { text: 'Company',  value: 'customerCompany'  },    
        { text: 'Country',  value: 'customerCountry'  },     
        { text: 'Amount',  align: 'right',value: 'amountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) }, 
        { text: 'Tax',  align: 'right',value: 'taxAmountFormatted' , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },   
        { text: 'Net Amount',  align: 'right',value: 'netAmountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },        
        { text: 'Received', align: 'right', value: 'receivedAmountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) }, 
        { text: 'Unpaid', align: 'right', value: 'unpaidAmountFormatted'  , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },   
        { text: 'Currency', value: 'currency.code' },
        { text: 'Actions', value: 'salesActions', sortable: false },
      ]
    },
    xlsxItems(){
      return this.salesFormatted.map((item) => {
        return {
          id: item.id,
          saleDate: item.saleDate,
          customer: item.customer.customerName,
          company: item.customer.company,
          country: item.customer.country.name,
          amount: item.amountFormatted ,
          received: item.receivedAmountFormatted,
          unpaid: item.unpaidAmountFormatted,
          currency: item.currency.code ,
          tax: item.taxAmountFormatted ,
          net: item.netAmountFormatted ,        
        }
      });
    },
    salesFormatted(){
      return this.sales.map((item) => {
        item.amountFormatted = formatPrice(item.amount);
        item.taxAmountFormatted = formatPrice(item.taxAmount);
        item.netAmountFormatted = formatPrice(item.amount - item.taxAmount);
        item.receivedAmountFormatted =  formatPrice(item.receivedAmount);
        item.customerName = concatStr(item.customer.customerName,25);
        item.customerCompany = concatStr(item.customer.company,25);
        item.customerCountry = concatStr(item.customer.country.name,20);
        let unpaidAmount = item.amount - item.receivedAmount;
        if(unpaidAmount<0) unpaidAmount = 0;
        item.unpaidAmountFormatted = formatPrice(unpaidAmount)
        return item;  
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Sale' : 'Edit Sale'
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    customersComputed(){
      return this.customers.map((item) => {
        item.customerName = item.customerName+" - "+item.company;
        return item; 
      })
    },
  },
  created() {    

    this.fillIntervalDates();
    this.getCurrencies();
    this.getCustomers();
    this.getSalePersonnels();
    this.getOfficePersonnels()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    showUnpaid(showUnpaid){
      if(this.salesStartDate && this.salesEndDate){        
        this.getSalesByInterval(this.salesStartDate,this.salesEndDate, showUnpaid);
        if(showUnpaid){
          this.totalText = 'Total Unpaid';
        }else{
          this.totalText = 'Total Sale';
        }
      }
    },
    salesStartDate (val){
      this.salesStartDate = val;
      if(val && this.salesEndDate){        
        this.getSalesByInterval(this.salesStartDate,this.salesEndDate, this.showUnpaid);
      }
    },
    salesEndDate(val){
      this.salesEndDate = val;
      if(val && this.salesStartDate){      
        this.getSalesByInterval(this.salesStartDate,this.salesEndDate, this.showUnpaid);
      }
    }
  },
  methods: { 
    goToOfferDetails(item){
      const routeData = this.$router.resolve('/offers/'+item.id);
      window.open(routeData.href, '_blank');
      //this.$router.push('/offers/'+item.id);
    },
    async fillIntervalDates(){
      await this.setEndDate();
      this.salesStartDate = getCurrentMonthStart();
    },
    async setEndDate(){
      this.salesEndDate = getCurrentDate();
    },
    editItem (item) {
      this.editedIndex = this.sales.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deleteSale(item);
      } 
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      if (this.editedIndex > -1) {        
        this.updateSale(this.editedItem);
      } else {
        this.addSale(this.editedItem);         
      }      
    },
    addSale(item){
      this.$axios.post(this.$apiurl + API_URL, {
        offerId: item.offer ? item.offer.id : 0,
        customerId: item.customer.id,
        currencyId: item.currency.id,
        salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,
        officePersonnelId: item.officePersonnel ? item.officePersonnel.id : null,
        amount: item.amount,
        saleDate:item.saleDate,
        explanation: item.explanation
      })
      .then(response => {        
        if (response.status === 201) {
          this.$radio.$emit('success', {message:'Sale Added Successfully'});
          this.sales.push(this.editedItem);
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateSale(item){
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        offerId: item.offer ? item.offer.id : 0,
        customerId: item.customer.id,
        currencyId: item.currency.id,
        salePersonnelId: item.salePersonnel ? item.salePersonnel.id : null,
        officePersonnelId: item.officePersonnel ? item.officePersonnel.id : null,
        amount: item.amount,
        taxAmount: item.taxAmount,
        saleDate:item.saleDate,
        explanation: item.explanation
      })
      .then(response => {
        if (response.status === 200) {
          this.$radio.$emit('success', {message:'Sale Updated Successfully'});
          Object.assign(this.sales[this.editedIndex], this.editedItem);
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteSale(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
        if (response.status === 200) {
          if(item.offer){
            this.updateOfferStatus(item.offer.id,"OPEN");
          }
          const index = this.sales.indexOf(item)
          this.sales.splice(index, 1);
          this.$radio.$emit('success', {message:'Sale Deleted Successfully'});
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateOfferStatus(offerId,status){
      this.$axios.post(this.$apiurl +'offers/'+offerId+'/status/'+status, {})
      .then(response => {        
        if (response.status === 200) {
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getSalesByInterval(startDate, endDate, showUnpaid){
      this.$axios.get(this.$apiurl + API_URL, { 
            params: {
              startDate: startDate,
              endDate: endDate,
              showUnpaid: showUnpaid
            }                                               
          })
          .then(response => {
            this.totalSaleAmount = response.data.totalAmount;
            this.totalSaleAmountUSD = response.data.totalAmountUSD;
            this.sales = response.data.saleList;
            if(!showUnpaid){
              this.totalSaleUSDAmountFormatted = formatPrice(this.totalSaleAmountUSD);
              this.totalSaleAmountFormatted = formatPrice(this.totalSaleAmount);
            }else{
              this.totalSaleUSDAmountFormatted = formatPrice(response.data.totalUnpaidAmountUSD);
              this.totalSaleAmountFormatted = formatPrice(response.data.totalUnpaidAmount);
            }
            
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getCurrencies(){     
      this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
          .then(response => {
              this.currencyList = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },  
    getCustomers(){     
      this.$axios.get(this.$apiurl + CUSTOMERS_API_URL)
          .then(response => {
              this.customers = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },  
    getSalePersonnels(){     
      this.$axios.get(this.$apiurl + SALESMAN_API_URL)
          .then(response => {
              this.salePersonnels = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    getOfficePersonnels(){     
      this.$axios.get(this.$apiurl + OFFICEMAN_API_URL)
          .then(response => {
              this.officePersonnels = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        (typeof value === 'string' || typeof value === 'number' ) &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
<style scoped>
.paymentNotReceived{
  color:red;
}
</style>
